'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var plugins = [
    'advlist autolink lists link image charmap print preview anchor',
    'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste imagetools help wordcount emoticons',
];
var toolbar = " fullscreen | formatselect | bold italic underline strikethrough forecolor backcolor |\nalignleft bullist numlist |\nremoveformat | link image emoticons table | help";

exports.plugins = plugins;
exports.toolbar = toolbar;
